var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"despreEO"},[_c('div',{staticClass:"chenarEO"},[_c('h1',{staticClass:"titluEO",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.title))}}),_c('p',{staticClass:"textEO",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.content))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }